import { useMemo } from 'react';
import { SWRConfiguration } from 'swr';
import { ILookup, ILookupItem } from '../../api/dtos';
import useConsentVersions from '../data/useConsentVersions';

export const PICF_VERSION_OTHER_ID = 0;

const useConsentVersionLookup = (propertyName: string, institutionCode?: string, picfTypeName?: string, configuration?: SWRConfiguration) => {
    const output = useConsentVersions(institutionCode, picfTypeName, configuration);

    const modifiedOutput = useMemo(() => {
        const lookupItems: ILookupItem[] = output.data ?
            Object.keys(output.data).map((key) => {
                return {
                    id: output.data![key as any as number].picfId as any,
                    value: output.data![key as any as number].version ?? ''
                }
            }) :
            [];
    
        lookupItems.push({
            id: PICF_VERSION_OTHER_ID as any,
            value: 'Other'
        });
    
        const lookups: ILookup = {
            propertyName: propertyName,
            items: lookupItems
        };

        return {
            ...output,
            data: lookups
        }
    }, [output, propertyName])

    return modifiedOutput;
};

export default useConsentVersionLookup;